import Vue from 'vue'

import firebase from 'firebase';


const state = {"assessments":[],"created":{"seconds":1604860672,"nanoseconds":856000000},"dashboard_settings":{},"display_name":"Günter Schmidt","email":"g.schmidt@m.works","email_verified":null,"first_name":"Gunter","has_assessment":false,"id":"x3tTLMFYvIMGAG3mHPbeWGGVJBM2","login_count":0,"last_name":"Schmidt","organisation":["RoHvoiRymMd4N2B"],"registration_method":"email","role":"user","updated":{"seconds":1604860672,"nanoseconds":857000000},"has_organisation":true};

const actions = {
  createUserDocument( {rootState, dispatch}  ){
    return new Promise((resolve) => {
      var now = firebase.firestore.Timestamp.fromDate(new Date());
      var user = {
        registration_method: rootState.auth.user.registration_method, 
        created: now,
        dashboard_settings: {},
        login_count: 0,
        role: "user",
        email: rootState.auth.user.email, 
        display_name: rootState.auth.user.display_name
      }
      if( rootState.auth.user.first_name ){
        user.first_name = rootState.auth.user.first_name
      }
      if( rootState.auth.user.last_name ){
        user.last_name = rootState.auth.user.last_name
      }
      dispatch("updateDoc", {
        doc: `users/${rootState.auth.user.uid}`, 
        data: user, 
        action: "set"
      }, {root: true}).then(() => {
        resolve()
      })
    })
  },
  getUserRole({state, dispatch, commit}){
    return new Promise((resolve) => {
      dispatch("getDoc", {
        doc: `users/${state.id}`
      }, {root: true}).then( (doc) => {
        resolve( doc.role )
        commit("SET_VALUE", {role: doc.role} );
      })
    })
  },
  watchUserDocument( {commit, state, dispatch }, id ){
    commit("SET_ID", id);
    var user = firebase.firestore().doc(`users/${id}`)
    var update = { };
    var subscription = user.onSnapshot( doc => {
      if( doc.data() ){
        var keys = Object.keys(state).filter( k => k !== 'id');
        keys.forEach( key => {
          if( doc.data()[key] ){
            update[key] = doc.data()[key];
          }
        })
        commit("SET_VALUE", update );
      }
      if( update.role ){
        dispatch("auth/setView", update.role, {root: true})
      }
      dispatch("computeUserProperties");
    })
    dispatch("updateUserDetailsFromAuth");
    commit("auth/LOG_SUBSCRIPTION", subscription, {root: true})
  },
  computeUserProperties({state, commit}){
    var update = {};
    update.has_organisation = state.organisation.length > 0 || 0;
    update.has_assessment = false;
    commit("SET_VALUE", update)
  },
  updateUserDetailsFromAuth({state, rootState, dispatch}){
    var update = {};
    var keys = ["display_name", "first_name", "last_name", "profile_image", "email" ]

    keys.forEach( key => {
      if( !state[key] && rootState.auth.user[key] ){
        update[key] = rootState.auth.user[key]
      }
    })
    if( Object.keys(update).length ){
      dispatch("updateDoc", {
        doc: `users/${state.id}`, 
        action: "update", 
        data: update
      }, {root: true})
    } 
  }, 
  getDashboardSettings({commit, rootState}){
    var pins = [];
    pins = pins.concat( rootState.groups.filter(a => a.pinned ).map( a => { a.pinType = "group"; return a; } ) );
    pins = pins.concat( rootState.users.filter(a => a.pinned ).map( a => { a.pinType = "user"; return a; } ) );
    pins = pins.concat(  rootState.collaborations.filter(a => a.pinned ).map( a => { a.pinType = "collaboration"; return a; } ) );
    var notes = rootState.groups.filter( a => a.notes ).flatMap(a => a.notes ) ;
    pins = pins.concat(  notes.filter( b => b.pinned ).map( a => { a.pinType = "note"; return a; } ) );
    commit("SET_PINS", pins)
  }, 
  saveChat( {dispatch}, message ){
    dispatch("addDoc",  {
      collection: "chats", 
      data: message
    }, {root: true }).then( () => {
      return true;
    })    
  }
}

const mutations = {
  SET_PINS(state, pin){
    Vue.set(state, "pins", pin)
  },
  SET_ID(state, id ){
    Vue.set(state, "id", id );
  },
  SET_VALUE(state, update ){
    for( var key in update ){
      Vue.set(state, key, update[key] );
    }
  }, 
  DELETE_USER(state){
    for( var key in state ){
      Vue.set(state, key, null );
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
